import React from 'react';
import InputNumberFormat from 'react-number-format';

import MdiGroupIcon from 'mdi-react/GroupIcon';

import { Box, Icon, Tr, Td, Text, Input } from '@chakra-ui/react';

import { Row, FlattenedComponent } from './types';

export type Composition = {
  price: number;
  unit_price_was_changed: boolean;
  unit_price_original: number;
  newQuantity: number;
  recursive_quantity: number;
  bdi_percent: number;
  budget_composition_price: {
    code: string;
    description: string;
    observation: string;
    immobilized: boolean;
    unit_price: number;
    id: number;
    unit_measure_id: {
      id: number;
      description: string;
    };
  };
  labor: number;
  material: number;
  labor_percent: number;
  material_percent: number;
  equipment: number;
  refund: number;
  third_party: number;
  other: number;

  composition_price: {
    base: {
      description: string;
    };
    version: {
      description: string;
    };
    composition: {
      code: string;
      description: string;
      version: {
        year?: number;
        month?: number;
        description: string;
        base: {
          description: string;
        };
      };
      unit_measure: {
        description: string;
      };
    };
  };
};

type Item = FlattenedComponent & Composition;

interface RowProps {
  row: Row & { original: Item };
  onUpdateComponentBDI: (id: number, bdi: number | undefined) => void;
}
const CompositionCustomRow: React.FC<RowProps> = ({
  row,
  onUpdateComponentBDI,
}) => {
  return (
    <Tr {...row.getRowProps()}>
      <Td>
        <Box
          display="flex"
          flexDir="column"
          ml="1"
          justifyContent="center"
          alignItems="center"
          title="Composição"
          fontWeight="bold"
        >
          {row.original.location} <Icon w={5} h={5} as={MdiGroupIcon} />
        </Box>
      </Td>

      <Td title="Base / Referência">
        <Text textAlign="center">Preço informado</Text>
      </Td>

      <Td>{row.original.budget_composition_price.code}</Td>

      <Td>
        <Text
          py={1}
          whiteSpace="pre-wrap"
          maxWidth={{ base: '100%', md: '650px' }}
        >
          {row.original.budget_composition_price.description}
        </Text>
      </Td>

      <Td isNumeric>
        {Intl.NumberFormat('pt-BR', {
          maximumFractionDigits: 4,
        }).format(row.original.quantity)}
      </Td>

      <Td isNumeric>
        <Text>
          {Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          }).format(row.original.social_law_price)}
        </Text>
      </Td>

      <Td isNumeric>
        {Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(row.original.price)}
      </Td>

      <Td isNumeric>
        <InputNumberFormat
          type="tel"
          customInput={Input}
          displayType="input"
          className="text-right"
          placeholder="0 %"
          fixedDecimalScale
          thousandSeparator="."
          decimalSeparator=","
          suffix=" %"
          decimalScale={2}
          value={row.original.bdi_percent}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              const currentElement = e.target as HTMLInputElement;

              const inputs = document.querySelectorAll('input');
              const currentIndex = Array.from(inputs).indexOf(currentElement);

              if (currentIndex !== -1 && currentIndex < inputs.length - 1) {
                const nextElement = inputs[currentIndex + 1];
                nextElement.focus();
              }
            }
          }}
          onFocus={(e) => e.target.select()}
          onValueChange={(v) => {
            onUpdateComponentBDI(row.original.id, v.floatValue);
          }}
        />
      </Td>

      <Td isNumeric>
        {Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        }).format(row.original.total)}
      </Td>
    </Tr>
  );
};

export default CompositionCustomRow;
